<script>
/**
 * Design options such as bgColor, padding, shadow and borderRadius
 * this.defaultBgColorConfig as an element of the config
 */

import { SColors } from '@/utils/constants';

export default {
  props: {
    designOptions: {
      type: Object,
      default: () => ({
        padding: 10,
        shadow: 1,
        borderRadius: 1,
        bgColor: SColors.grayBodyBackground,
      }),
    },
    bgColor: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      designOptionsRef: 'bg-color-component-ref',
    };
  },
  computed: {
    defaultBgColorConfig() {
      return {
        key: 'designOptions',
        value: this.designOptions,
        component: 'ExpandableWidgetDesign',
        options: {
          ref: this.designOptionsRef,
          title: this.$t('message.CFG_W_DESIGN_OPTIONS'),
        },
      };
    },
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    'designOptions.padding'() {
      this.resize();
    },
  },
};
</script>
